import type { Prototype } from "../prototype-types";

export const kevinChikPrototypes: Prototype[] = [
  {
    id: "kch-bestsellers-list-view",
    name: "Bestsellers List View",
    path: "/kch/bestsellers-list-view",
    description:
      "Brand page opened on the Bestsellers tab in list view. The bestseller assortment reads as the line-sheet table — product, item, case, WSP, MSRP, quick add — with a Grid/List toggle to compare it against the tile grid.",
    owner: "Kevin Chik",
    createdAt: "2026-08-12",
    lastUpdated: "2026-08-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/b29502f974555bf22e71e82c430fc4f113ee84643569986d59608c2d1976af29.png",
    creationTool: "claude-code",
  },
  {
    id: "kch-brand-page-list-view",
    name: "Brand Page List View",
    path: "/kch/brand-page-list-view",
    description:
      "Brand page catalog with a Grid/List toggle. The List view extends the reorder tab line-sheet table to the full catalog: product, WSP, last ordered, availability, and inline quantity.",
    owner: "Kevin Chik",
    createdAt: "2026-08-06",
    lastUpdated: "2026-08-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/kch-brand-page-list-view.png",
    creationTool: "claude-code",
  },
  {
    id: "kch-ships-now-product-grid",
    name: "Ships Now Product Grid",
    path: "/kch/ships-now-product-grid",
    description:
      'Brand page product grid where in-stock products show a preorder ship date of "Ships now". Toggle the variant to compare against tiles with no ship date.',
    owner: "Kevin Chik",
    createdAt: "2026-10-29",
    lastUpdated: "2026-10-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/kch-ships-now-product-grid.png",
    creationTool: "claude-code",
  },
];
